import { render, staticRenderFns } from "./ReportedUsers.vue?vue&type=template&id=f91d74c8&scoped=true&"
import script from "./ReportedUsers.vue?vue&type=script&lang=js&"
export * from "./ReportedUsers.vue?vue&type=script&lang=js&"
import style0 from "./ReportedUsers.vue?vue&type=style&index=0&id=f91d74c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91d74c8",
  null
  
)

export default component.exports